export default {
  goBack: {
    id: 'buyback_step_device_go_back',
    defaultMessage: 'Buyback',
  },
  loading: {
    id: 'buyback_step_device_loading',
    defaultMessage: 'Loading',
  },
  continue: {
    id: 'swap_confirmation_continue',
    defaultMessage: 'Continue',
  },
  refreshPage: {
    id: 'buyback_step_refresh_page',
    defaultMessage: 'Sorry, something went wrong! Please refresh the page.',
  },
}
